import QueryString from "qs";
import * as React from "react";
import ReactPaginate from "react-paginate";
import { useLocation, useNavigate } from "react-router-dom";

interface IDataGridPagination {
  page?: number;
  totalPages?: number;
  totalResults?: number;
  startIndex?: number;
  endIndex?: number;
}

/**
 * Data Grind Pagination Reusable Component
 * @date 4/13/2023 - 1:57:46 PM
 *
 * @param {{ rowsPerPage: any; currentPage: any; }} {
    rowsPerPage, currentPage
}
 * @returns {*}
 */

const DataGridPagination: React.FC<IDataGridPagination> = ({
  totalResults,
  totalPages,
  endIndex,
  startIndex,
  // page,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const handlePageChange = (selectedPage: { selected: number }) => {
    query.page = (selectedPage.selected + 1).toString();

    navigate({
      search: QueryString.stringify(query),
    });
  };
  return (
    <div
      className='align-items-center d-flex flex-column flex-md-row justify-content-between mb-2 mt-2'
      style={{ padding: "0.6rem 0.75rem 0 0.75rem" }}
    >
      <div
        className='fw-semibold pageShowText mb-2 mb-md-0'
        style={{ fontSize: "0.72rem", color: "#6b7280" }}
      >
        Showing {startIndex} to {endIndex} of {totalResults} entries
      </div>
      <ReactPaginate
        previousLabel='Previous'
        nextLabel='Next'
        pageClassName='page-item'
        pageLinkClassName='page-link'
        previousClassName='page-item'
        previousLinkClassName='page-link'
        nextClassName='page-item'
        nextLinkClassName='page-link'
        breakClassName='page-item'
        breakLinkClassName='page-link'
        containerClassName='flex-wrap justify-content-center mb-0 pagination user-select-none'
        activeClassName='active'
        pageCount={totalPages || 0}
        marginPagesDisplayed={1}
        pageRangeDisplayed={4}
        onPageChange={handlePageChange}
        forcePage={Number(query.page) - 1 || 0}
      />
    </div>
  );
};
export default DataGridPagination;
